import { useRef } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { BestOffers } from 'widgets/kyrgyzstan/best-offers'

import { kyrgyzstanBestOffersStore } from 'entities/kyrgyzstan/model'

import { useInfiniteScroll } from 'shared/hooks/use-infinity-scroll'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const KyrgyzstanBestOffersPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { loadMore, hasMore, isLoading } = kyrgyzstanBestOffersStore

  const targetRef = useRef<HTMLDivElement>(null)

  useInfiniteScroll({
    targetRef,
    canLoad: hasMore && !isLoading,
    onLoad: () => {
      void loadMore()
    },
  })

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <div className={s.container}>
      <HeaderGoBack
        buttonWhite
        variant="grey"
        title={t('kyrgyzstan_block.offers.title')}
        onGoBack={handleGoBack}
      />

      <BestOffers isShowHeader={false} />

      <div ref={targetRef} />
    </div>
  )
})

export default KyrgyzstanBestOffersPage
